import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EmployeeAgreementlistComponent } from './employee-agreementlist.component';

const routes: Routes = [{ path: '', component: EmployeeAgreementlistComponent,pathMatch:'full'}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmployeeAgreementlistRoutingModule { }
